import { render, staticRenderFns } from "./pagesection.vue?vue&type=template&id=499d1481&scoped=true"
import script from "./pagesection.vue?vue&type=script&lang=js"
export * from "./pagesection.vue?vue&type=script&lang=js"
import style0 from "./pagesection.vue?vue&type=style&index=0&id=499d1481&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499d1481",
  null
  
)

export default component.exports